
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const RoadmapItem = ({ item, i }) => {
    return <li className={'roadmap_item'}>
        <div className="roadmap_item_phase">
            <img src={`/img/pages/home/roadmap/phase_${item.phase}.png`} alt={`$PEPD roadmap`}/>
            <h3><span>{item.title}</span><span>{item.phase}</span></h3>
        </div>
        <ol className={'roadmap_item_list'}>
            {item.items.map(el => {
            return <li key={el} className={'list_item'}>{el}</li>;
        })}
        </ol>
    </li>;
};
const Roadmap = ({ t }) => {
    const roadmap = t('home:roadmap', {}, { returnObjects: true });
    return (<section className={'roadmap'} id={'roadmap'}>
            <div className="container">
                <h2 className={'roadmap_title'}>{roadmap.title}</h2>
                <div className="roadmap_wrapper">
                    <ul className={'roadmap_items'}>
                        {roadmap.items.map((item, i) => {
            return <RoadmapItem i={i} key={item.phase} item={item}/>;
        })}
                    </ul>
                </div>
            </div>
        </section>);
};
export default Roadmap;

    async function __Next_Translate__getStaticProps__1989dd5010b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//home/Roadmap/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1989dd5010b__ as getStaticProps }
  